import {object, array, number} from 'yup';
import {messages} from '../../../../utils/messages';
import {ProductShape, currencyCode} from './product';

// Export schema
export const productAddShippingInfo = object().shape({
  currencyCode,
  actionField: object().shape({
    shipping: number().optional(),
    shippingTier: number().optional(),
  }).noUnknown(messages.NO_UNKNOWN),
  products: array().of(object().shape(ProductShape)).required(
    'productAddShippingInfo requires an array of products.',
  ),
}).noUnknown(messages.NO_UNKNOWN);